import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { EyeIcon } from '@heroicons/react/24/outline'

import useServer from '../../api/useServerMain'
import { cleanObj } from '../../utils/helpers'
import Input from '../forms/Input'
import Button from '../misc/Button'

interface PasswordModal {
  closeModal: () => void
}

const PasswordModal = ({ closeModal }: PasswordModal) => {
  const { editUser, isFetching } = useServer()
  const { control, handleSubmit, watch } = useForm({
    mode: 'onChange',
  })
  const onSubmit: SubmitHandler<Record<string, string | number>> = (data) => {
    delete data.probePassword
    editUser(cleanObj(data), closeModal)
  }

  const passw = watch('password')
  const [showPsw, setShowPsw] = useState(false)
  const [showPin, setShowPin] = useState(false)
  const pinUnicode = '\u{25CF}\u{25CF}\u{25CF}\u{25CF}\u{25CF}\u{25CF}'

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 className="text-center text-lg font-semibold text-slate-600 underline">
        Cambiar Contraseña
      </h2>
      <div className="my-3 grid grid-cols-2 gap-3">
        <div className="relative">
          <EyeIcon
            className="absolute right-2 top-10 z-10 h-5 text-gray-500 hover:cursor-pointer hover:text-gray-600"
            onClick={() => setShowPsw(!showPsw)}
          />

          <Input
            control={control}
            label="Nueva Contraseña"
            name="password"
            placeholder={showPsw ? 'Nueva contraseña' : '******'}
            type={showPsw ? 'text' : 'password'}
          />
        </div>

        <div className="relative">
          <EyeIcon
            className="absolute right-2 top-10 z-10 h-5 text-gray-500 hover:cursor-pointer hover:text-gray-600"
            onClick={() => setShowPsw(!showPsw)}
          />
          <Input
            control={control}
            label="Confirmar contraseña"
            name="probePassword"
            placeholder={showPsw ? 'Repetir contraseña' : '******'}
            rules={{
              validate: {
                match: (value) =>
                  (value ?? '') === (passw ?? '') ||
                  'Las contraseñas deben coincidir',
              },
            }}
            type={showPsw ? 'text' : 'password'}
          />
        </div>
        <div className="relative col-span-2">
          <EyeIcon
            className="absolute right-2 top-10 z-10 h-5 text-gray-500 hover:cursor-pointer hover:text-gray-600"
            onClick={() => setShowPin(!showPin)}
          />
          <Input
            control={control}
            label="Nuevo PIN"
            name="pinPassword"
            placeholder={showPin ? 'PIN' : pinUnicode}
            rules={{
              maxLength: {
                value: 6,
                message: 'No puede exceder los 6 caracteres',
              },
            }}
            textAsNumber
            type={showPin ? 'text' : 'password'}
          />
        </div>
      </div>
      <Button
        color="slate-600"
        disabled={isFetching}
        full
        loading={isFetching}
        name="Actualizar"
        type="submit"
      />
    </form>
  )
}

export default PasswordModal
